export const KEY_TOKEN = 'KEY_TOKEN';
export const KEY_EVENT = 'KEY_EVENT';
export const KEY_SESSION= 'KEY_SESSION';


// WEBPACK FOOTER //
// ./src/constants/local-storage.js